// Shared formatting helpers for the suggestion prompt builders
// (suggested-prompts, collection-suggested-prompts, suggested-searches).

/**
 * Render a list of already-shown suggestions as a trimmed, non-empty, numbered
 * list — used to tell the model which suggestions to avoid repeating when the
 * user hits the refresh button. Returns null when nothing usable remains.
 *
 * @param {string[]} exclude - Suggestions already shown this session.
 * @returns {string|null}
 */
export const formatExclude = exclude => {
  const cleaned = (exclude || []).map(t => (t || '').trim()).filter(Boolean)
  return cleaned.length === 0 ? null : cleaned.map((t, i) => `${i + 1}. ${t}`).join('\n')
}
